<style scoped>
.h-btn {
    min-width: 200px;
}

.no-href-dec {
    text-decoration: none;
    cursor: pointer;
}
.branch-select{
    min-width:200px
}
._btn {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    padding: 7px 12px;
}

._btn {
    margin: 0 !important;
    line-height: 1;
    color:#fff;
}
.staff-service-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 7px;
    padding: 16px 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 85px;
}

.staff-info {
    min-width: 0;
    padding-right: 12px;
}

.staff-info h6 {
    margin: 0 0 5px;
    font-size: 15px;
    font-weight: 600;
    color: #343a40;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.staff-info span {
    font-size: 12px;
    color: #6c757d;
}

/* Service counter */

.staff-services {
    width: 58px;
    height: 58px;
    border-radius: 50%;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    flex-shrink: 0;
    color: #fff;
}

.staff-services strong {
    font-size: 17px;
    font-weight: 700;
    line-height: 18px;
}

.staff-services small {
    font-size: 8px;
    text-transform: uppercase;
    line-height: 10px;
}


/* Success */

.success-card {
    border-left: 3px solid #198754;
}

.success-card .staff-services {
    background: #198754;
}


/* Primary */

.primary-card {
    border-left: 3px solid #0d6efd;
}

.primary-card .staff-services {
    background: #0d6efd;
}


/* Warning */

.warning-card {
    border-left: 3px solid #ffc107;
}

.warning-card .staff-services {
    background: #ffc107;
    color: #212529;
}


/* Danger */

.danger-card {
    border-left: 3px solid #dc3545;
}

.danger-card .staff-services {
    background: #dc3545;
}
</style>
<template>
    <!-- Content -->
    <div class="content-wrapper">
        <div class="row mb-3">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-12 d-flex justify-content-between">
                    <h3 class="font-weight-bold">Sales Records Reports</h3>
                    <button v-if="user.role > 1" type="button" 
                      @click="showStaffModal(0, staff)"  class="btn btn-primary me-2">Add Records</button>
                   </div>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-12">
                    
                    <div class="row mb-3">
                        <div class="col-sm-6 col-md-3 col-12 stretch-card col-grid">
<input type="text" v-model="this.filter_parcel"
                                                class="form-control"
                                                placeholder="Search to filter">
                        </div>
                        
                           <div class="col-sm-12 col-md-1 col-12 stretch-card col-grid"></div>
                            <div v-if="user.role == 2" class="col-sm-8 col-md-2 col-12 stretch-card col-grid"></div>  
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
 <input class="date_input form-control" v-model="this.fdate" type="date">
                    </div>
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                         <input class="date_input form-control" type="date" v-model="this.tdate">
                    </div>
                    
                     <div v-if="user.role == 3" class="col-sm-8 col-md-2 col-12 stretch-card col-grid">
                       
                                            <select v-model="branch_from"  @change="filterBranches" class="form-select form-control">
                                                <option v-for="branch in staff_branches" :key="branch.id" :value="branch.id">
                                                    {{ branch.name }}
                                                </option>
                                            </select>

                                        </div>
                  
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                         <button id="filter_btn" @click="filterRecords" class="btn btn-primary simple-btn">Filter</button>
                    </div>
                       
                    </div>
                  
                    <div class="row">
                        <div class="col-12">
                            <h4 class="my-3 text-center">{{heading}}</h4>
                              <div v-if="loading" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>
                <div class="table-responsive">
                    
                    <table class="table table-striped mt-3">
                        <thead>
                            <tr class="thead-style">
                                <th>No</th>
                                <th>Sale Name</th>
                                <th>Sale Phone</th>
                                <th>Amount</th>
                                <th>Branches</th>
                                <th>Record By </th>
                                 <th>Date Issue</th>
                                <th>Created At</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody id="incoming-list">

                            <tr v-for="(parcel, index) in paginatedParcels" :key="parcel.id" :id="'parcel_'+parcel.id">
                                <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                               
                                 <td class="text-capitalize">
                                    {{ parcel.fulname }}
                                </td>
                                <td class="text-capitalize">
                                    {{ parcel.phone }}
                                </td>
                                <td><label class="badge badge-dark"><PriceFormat :Price="parcel.amount"/></label></td>
                                <td class="text-capitalize">
                                    {{ parcel.branch_name }}
                                </td>
                               

                               <td class="text-capitalize">
                                   {{ parcel.created_by_name }}
                                </td>
                                 <td class="text-capitalize">
                                    <DateFormat :Date_="parcel.date_issue"/>
                                </td>
                                <td class="text-capitalize">
                                    
                                    <span class="d-block mt-1 text-muted"><DateFormat :Date_="parcel.created_at"/></span>
                                </td>
            
                                <td>
                                    <button
    v-if="canEditParcel(parcel)"
    type="button"
    @click="showStaffModal(1, parcel)"
    class="edit_btn btn btn-success btn-icon"
>
    <i class="fa fa-edit"></i>
</button>
                                               
                                </td>
                            </tr>
                          
                        </tbody>
                    </table>
                </div>
                           <div class="pagination-wrapper">

  <button 
    @click="currentPage--"
    :disabled="currentPage === 1">
    Prev
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="{ active: currentPage === page }">
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages">
    Next
  </button>

</div>
                        </div>
                    </div>

   
               
            </div>
        </div>
    </div>

        <!-- create Modal -->
<div class="modal fade mobile-full-width" id="createModal" tabindex="-1" data-bs-backdrop="static"
    data-bs-keyboard="false" role="dialog" aria-labelledby="createModal" aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">

        <div class="modal-content">
            <div class="modal-header">
                <h4 class="font-weight-bold">{{ form_label }}</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                </button>
            </div>
            <div class="container mt-3 mb-3">
                <form id="create-staff-form">
                    <div class="create-post-body">
                        <div v-if="loading_create" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>
                        <div class="row">
                            <div class="col-sm-12 col-md-12">
                                <div class="row">
                                    <div class="col-sm-6 col-md-6">
                                        <div class="form-group">
                                            <label class="form-label">Full name *</label>
                                            <input v-model="staff.fulname" class="form-control" maxlength="50"
                                                required type="text" placeholder="fullname">
                                        </div>


                                    </div>
                                    <div class="col-sm-6 col-md-6">
                                        <div class="form-group">
                                            <label class="form-label">Amount *</label>
                                            <input :value="formatMoney(staff.amount)"
    @input="updateMoney('amount', $event)"  type="text"
    inputmode="numeric" class="form-control"
                                                required placeholder="100">
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-md-6">
                                        <div class="form-group">
                                            <label class="form-label">Phone *</label>
                                            <input v-model="staff.phone" class="form-control" maxlength="20"
                                                required type="text" placeholder="0xxxxxxxxx">
                                        </div>
                                    </div>
                                    <div class="col-sm-6 col-md-6">
                                        <div class="form-group">
                                            <label class="form-label">Issued Date </label>
                                            <input v-model="staff.date_issue" class="form-control" maxlength="20"
                                                type="datetime-local" placeholder="">
                                        </div>
                                    </div>
                                  

                                    <div v-if="staff.id == 0" class="col-sm-12 col-md-12">
                                        <div class="alert alert-danger">
                                            <p>Once you add the records you will Never Delete it, but you may Edit it within 24hrs</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="create-post-bottom">
                        <button class="btn btn-primary" @click="createUpdated" type="button" id="submit-create-staff">{{ form_label }}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

</template>
<script>
import axios from "axios";

import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";


export default {
    components: {
        PriceFormat,
        PhoneFormat,
        DateFormat,

    },
    data() {
        return {
            loading: false,
            loading_event:false,
            search_staff:"",
            filter_parcel:"",
            heading:"To Days Serviced Parcels Reports",
            parcels:[],
            og_parcels:[],
            events:[],
            parcel:{},
            client:"receiver",
            fdate:"",
            tdate:"",
            staff_branches: [],
            branch_from:0,
            staff: {
                id: 0,
                fulname: '',
                phone: '',
                amount: 100,
                date_issue:this.getCurrentDateTime(),
            },
            currentPage: 1,
            perPage: 30,
            user: this.$attrs.user
        };
    },
    methods: {

                     async createUpdated() {

            var staff = this.staff


            var response = await axios
                .post(this.$store.state.api_url + "/sales/records-insertion", staff)
                .catch((errors) => {
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                window.location.reload();
               
            } else {
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

        canEditParcel(parcel) {
    if (!parcel.created_at || this.user.id != parcel.staff_id) {
        return false;
    }

    const createdAt = new Date(parcel.created_at);
    const now = new Date();

    const difference = now - createdAt;

    // 24 hours in milliseconds
    const twentyFourHours = 24 * 60 * 60 * 1000;

    return difference >= 0 && difference <= twentyFourHours;
},

formatMoney(value) {
        if (value === null || value === undefined || value === "") {
            return "";
        }

        return Number(value).toLocaleString("en-US");
    },

    updateMoney(field, event) {
        // Remove commas and anything that isn't a number
        let value = event.target.value.replace(/,/g, "").replace(/\D/g, "");

        // Store as integer
        this.staff[field] = value ? Number(value) : "";
    },

           showStaffModal(type, staff){


            if(type == 0){
                this.staff = {
                id: 0,
                fulname: '',
                phone: '',
                amount: 100,
                date_issue:this.getCurrentDateTime(),
            }

            this.form_label = "Create Records"
            }else{
                this.staff = staff
                this.staff.date_issue = this.formatDateTime(staff.date_issue)
                this.form_label = "Update Records"
            }

            const modal = bootstrap.Modal.getOrCreateInstance(
                document.getElementById("createModal")
            );

            modal.show();
        },
formatDateTime(date) {
    const d = new Date(date);

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    const seconds = String(d.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
},
        getCurrentDateTime() {
            const now = new Date();

            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, "0");
            const day = String(now.getDate()).padStart(2, "0");

            const hours = String(now.getHours()).padStart(2, "0");
            const minutes = String(now.getMinutes()).padStart(2, "0");
            const seconds = String(now.getSeconds()).padStart(2, "0");

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },

        async getRecords() {

            this.loading = true

            var response = await axios
                .get(this.$store.state.api_url + "/sales/sales-records")
                .catch((errors) => {
                    this.loading = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {
                this.loading = false
                this.parcels = response.data.sales;
                this.og_parcels = response.data.sales

                 this.heading = "To Days Sale's Reports Total is TZS :"+Number(response.data.total || 0).toLocaleString();
                

                this.staff_branches = [{id:0,name:"All Branches"},...response.data.branches]
               

               console.log(this.parcels)

            } else {
                this.loading = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

          async filterRecords(){

             this.loading = true
          var fdate = this.fdate
          var tdate = this.tdate

        var branch = this.branch_from

          var response = await axios
              .post(this.$store.state.api_url + "/sales/filter-sales-records", {fdate, tdate, branch})
              .catch((errors) => {
                    this.loading = false
                  var message = "Network or Server Errors";
                  this.$toast.error(message, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {

               this.loading = false

                this.parcels = response.data.sales;
                this.og_parcels = response.data.sales
               
               this.heading = "Sales Reports From ("+fdate+" To "+tdate+") Total is TZS :"+Number(response.data.total || 0).toLocaleString();
             
          } else {
                this.loading = false
              var message = response.data.message;
              this.$toast.error(message, { duration: 5000, dismissible: true });
          }

        },
        updateParcel(id, type) {
    const parcel = this.parcels.find(item => item.id == id);

    if (parcel) {
        parcel.type = type;
        parcel.events = (parcel.events || 0) + 1;
    }
},
      filterBranches() {
        const id = Number(this.branch_from);

        if (id === 0) {
            // Show all branches
            this.parcels = [...this.og_parcels];
        } else {
            // Show only selected branch
            this.parcels = this.og_parcels.filter(
                staff => Number(staff.branch_id) === id
            );
        }
    },
         nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
    }
  },

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--
    }
  },

    },
      computed: {

  paginatedParcels() {
    const start = (this.currentPage - 1) * this.perPage
    const end = start + this.perPage

    return this.parcels.slice(start, end)
  },

  totalPages() {
    return Math.ceil(this.parcels.length / this.perPage)
  },
  

},
    watch: {

        filter_parcel(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.parcels = this.og_parcels
                return
            }

            this.parcels = this.og_parcels.filter(parcel => {

                return (
                    (parcel.name && parcel.name.toLowerCase().includes(term)) ||
                    (parcel.price && parcel.price.toLowerCase().includes(term)) ||
                    (parcel.sender_name && parcel.sender_name.toLowerCase().includes(term)) ||
                    (parcel.receiver_name && parcel.receiver_name.toLowerCase().includes(term)) ||
                    (parcel.receiver_phone && parcel.receiver_phone.toLowerCase().includes(term)) ||
                    (parcel.sender_phone && parcel.sender_phone.toLowerCase().includes(term)) ||
                    (parcel.tag_name && parcel.tag_name.toLowerCase().includes(term)) ||
                    (parcel.branch_from_name && parcel.branch_from_name.toLowerCase().includes(term))  ||
                    (parcel.branch_to_name && parcel.branch_to_name.toLowerCase().includes(term)) 
                )
            })
        },
 
    },
    created() {
        this.$store.state.page_name = "Dashbord"
        this.getRecords()
    },
    mounted() {
        //$('#dashbord').attr('class', 'nav-item active');
    }
};
</script>
